import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, DSSetup } from 'webapp-types';

export default class ClientMetricRecord extends Model {
	@attr('number') spaceId!: number;
	@attr('number') order!: number;
	@attr('number') blockId!: number;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	dateRange!: DateRangeInterface.FormulaInterface;
	@attr('string')
	metricSetupKey!: string;
	@attr('number') metricSetupSpaceAccessId!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricSetupDimensions!: string[];
	@attr('object') metricSetupFilters!: DSSetup.MetricSetupFiltersData | null;
}
